import { ArrowUpRight, Globe, Instagram } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Eyebrow, FadeUp, MaskLine } from "./Reveal";

const PARTNERS = [
  { id: "shotzone", name: "Shot Zone", logo: "/img/shotzone-logo.png", mark: "/img/shotzone-mark.png",
    website: "https://shot-zone.com", websiteLabel: "shot-zone.com",
    instagram: "https://www.instagram.com/shotzoneshop/", instagramLabel: "@shotzoneshop" },
];

const LinkBtn = ({ href, icon: Icon, label, testid }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
    className="group/l flex items-center justify-between gap-4 border-t border-[var(--line)] py-4 font-mono text-xs uppercase tracking-[0.2em] hover:text-white transition-colors">
    <span className="flex items-center gap-3"><Icon className="w-4 h-4" />{label}</span>
    <ArrowUpRight className="w-4 h-4 transition-transform group-hover/l:rotate-45" />
  </a>
);

export const Partners = () => {
  const { t } = useLang();
  return (
    <section id="partners" data-testid="partners-section" className="px-5 sm:px-8 lg:px-12 py-24 sm:py-32 border-t border-[var(--line)]">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Eyebrow>{t("pt.eyebrow")}</Eyebrow>
          <h2 className="font-display font-black uppercase text-5xl sm:text-7xl leading-[0.85] mt-5">
            <MaskLine>{t("pt.title")[0]}</MaskLine>
            <MaskLine delay={0.1}>{t("pt.title")[1]}</MaskLine>
          </h2>
        </div>
        <FadeUp className="max-w-sm text-sm sm:text-base text-[var(--muted)] leading-relaxed">{t("pt.intro")}</FadeUp>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PARTNERS.map((p) => (
          <FadeUp key={p.id}>
            <div data-testid={`partner-card-${p.id}`} className="group clip-cut bg-[var(--ink-2)] border border-[var(--line)] p-6 sm:p-8 hover:border-[var(--bone)]/50 transition-colors">
              <div className="h-40 flex items-center justify-center gap-6 border border-[var(--line)] bg-black mb-6">
                <img src={p.mark} alt="" aria-hidden="true" className="h-20 w-auto grayscale group-hover:grayscale-0 transition-[filter] duration-700" />
                <img src={p.logo} alt={`${p.name} logo`} className="h-6 sm:h-7 w-auto grayscale group-hover:grayscale-0 transition-[filter] duration-700" />
              </div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--muted)]">{t(`pt.${p.id}`)}</p>
              <h3 className="font-display text-4xl font-black uppercase mt-2 mb-6">{p.name}</h3>
              <LinkBtn href={p.website} icon={Globe} label={p.websiteLabel} testid={`partner-${p.id}-website`} />
              <LinkBtn href={p.instagram} icon={Instagram} label={p.instagramLabel} testid={`partner-${p.id}-instagram`} />
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
